module.exports = __webpack_public_path__ + "static/loop-5bd411993169c2bfa9ec97e92ac5c9e4.png";